// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SearchPeopleSvg from '@rsuite/icon-font/lib/people/SearchPeople';
var SearchPeople = createSvgIcon({
  as: SearchPeopleSvg,
  ariaLabel: 'search people',
  category: 'people',
  displayName: 'SearchPeople'
});
export default SearchPeople;